import Advantage from '~/components/advantage';

import {
  getAppUrl,
  getDocsUrl,
  getGitHubUrl,
  getBuddyMarketingUrl
} from '~/helpers/url';

export default function CommonAdvantages() {
  return (
    <>
      <Advantage>
        <Advantage.Header>
          Free, <br />Always
        </Advantage.Header>
        <Advantage.Content>
          The service is free of charge. Sponsored by{' '}
          <a href={getBuddyMarketingUrl()} className="link">
            Buddy CI/CD
          </a>
        </Advantage.Content>
      </Advantage>
      <Advantage>
        <Advantage.Header>
          Open <br />Source
        </Advantage.Header>
        <Advantage.Content>
          All sources are available on{' '}
          <a className="link" href={getGitHubUrl()}>
            GitHub
          </a>{' '}
          under MIT license. We love open source!
        </Advantage.Content>
      </Advantage>
      <Advantage>
        <Advantage.Header>
          Cloud &<br />On-premises
        </Advantage.Header>
        <Advantage.Content>
          You can use the{' '}
          <a href={getAppUrl()} className="link">cloud version</a>
          {' '}or{' '}
          <a href={getDocsUrl('standalone')} className="link">install it</a>
          {' '}on your own server.
        </Advantage.Content>
      </Advantage>
      <Advantage>
        <Advantage.Header>
          PHP<br />Composer
        </Advantage.Header>
        <Advantage.Content>
          <a href={getDocsUrl('proxy')} className="link">
            Easy setup
          </a>{' '}
          with Composer PHP and access token.
        </Advantage.Content>
      </Advantage>
      <Advantage>
        <Advantage.Header>
          Git, SVN<br />and Mercurial
        </Advantage.Header>
        <Advantage.Content>
          Add private packages from the most popular VCS&apos;s.
        </Advantage.Content>
      </Advantage>
    </>
  );
}
